export const LOGOUT = 'LOGOUT';

export const logout = () => ({
  type: LOGOUT
});



// WEBPACK FOOTER //
// ./src/actions/Logout.js